import { logger, LogLevel } from '@fiverr-private/obs';

interface LogEnrichment extends Record<string, any> {
    error?: Error;
}

const logMessage =
    (level: LogLevel) =>
    (message: string, { error, ...enrichment }: LogEnrichment = {}) => {
        logger[level]({
            message,
            package: '@fiverr-private/identification_core',
            ...(error && {
                stack: error.stack,
            }),
            ...enrichment,
        });
    };

export const logError = logMessage('error');
export const logWarn = logMessage('warn');
